<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="65 0 394.901 508.878"
        width="200px"
        height="200px"
    >
        <path
            style="fill: rgb(122, 185, 232); stroke-width: 0.248"
            d="M 447.399 211.789 L 405.084 211.789 L 405.084 84.569 L 292.257 84.569 L 292.257 42.166 C 292.257 18.742 273.315 -0.244 249.948 -0.244 C 226.576 -0.244 207.635 18.742 207.635 42.166 L 207.635 84.569 L 94.807 84.569 L 94.807 211.789 L 137.104 211.789 C 160.492 211.789 179.43 230.772 179.43 254.196 C 179.43 277.617 160.492 296.602 137.104 296.602 L 94.807 296.602 L 94.807 423.82 L 207.638 423.82 L 207.638 466.225 C 207.638 489.649 226.58 508.634 249.948 508.634 C 273.315 508.634 292.257 489.645 292.257 466.225 L 292.257 423.816 L 405.084 423.816 L 405.084 296.597 L 447.399 296.597 C 470.766 296.597 489.708 277.612 489.708 254.193 C 489.708 230.772 470.766 211.789 447.399 211.789 Z"
        />
        <path
            style="fill: rgb(87, 154, 223); stroke-width: 0.248"
            d="M 447.399 211.789 L 405.084 211.789 L 405.084 84.569 L 292.257 84.569 L 292.257 42.166 C 292.257 18.742 273.315 -0.244 249.948 -0.244 L 249.948 508.631 C 273.315 508.631 292.257 489.645 292.257 466.225 L 292.257 423.816 L 405.084 423.816 L 405.084 296.597 L 447.399 296.597 C 470.766 296.597 489.708 277.612 489.708 254.193 C 489.708 230.772 470.766 211.789 447.399 211.789 Z"
        />
    </svg>
</template>

<script>
export default {
    name: "ComponentSvg",
};
</script>
